<template>
  <div id="editMntCategory">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ $t('LanguageLib.MNT_CATEGORY_INFO') }}</span>
    </div>
    <div class="content">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave"
                 style="margin-bottom: 7px;">{{$t('LanguageLib.SAVE')}}
      </el-button>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <h4>{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
        <div class="contentTop">
          <el-checkbox :disabled="type==='add'?true:false" v-model="ruleForm.autoApproval">
            {{$t('LanguageLib.AUTOMATIC_APPROVAL')}}
          </el-checkbox>
          <template v-if="type==='edit'">
            <el-checkbox v-model="ruleForm.stackShelves">{{$t('LanguageLib.STACK_SHELVES')}}</el-checkbox>
          </template>
        </div>
        <div class="contentInfo">
          <h4>{{$t('LanguageLib.BASIC_INFORMATION')}}</h4>
          <div class="infoForm">
            <!--序号-->
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SERIAL_NUMBER')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" oninput="this.value=this.value.replace(/[^\d]/g,'');"
                          :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.serialNumber" maxlength="9">
                </el-input>
              </el-form-item>
            </div>
            <!--            类别名称-->
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.CLASSIFICATION_NAME')}}</p>
              <el-form-item style="min-width: 700px" prop="categoryName">
                <el-input style="width: 320px;display: inline-block" :placeholder="$t('LanguageLib.PleaseEnter')"
                          v-model="ruleForm.categoryName"
                          @change="inputCategory"
                          maxlength="50">
                </el-input>
                <el-select style="display: inline-block;width: 122px" v-model="currentLang"
                           @change="changeLanguage"
                           :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <span slot="prefix" v-if="currentLang===OwnerLanguage" style="position: relative;color: red">*</span>
                  <el-option
                    v-for="item in langList"
                    :key="item.id"
                    :label="item.content"
                    :value="item.id"
                  >
                    <div><span style="color: red" v-if="item.id===OwnerLanguage">*</span>
                      <span v-else style="visibility: hidden">*</span>
                      {{item.content}}
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <!--          上级分类-->
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SUBHEADINGS')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" class="TeInput" v-model="ruleForm.parent.name"
                          :placeholder="$t('LanguageLib.PLEASE_CHOOSE')"
                          :disabled="subDisabled">
                  <el-button @click="openCategoryList" class="openOrgList" slot="append" :style="styleStrRegion"
                             :disabled="subDisabled"
                             icon="el-icon-more"></el-button>
                </el-input>
              </el-form-item>
            </div>

            <el-dialog :visible.sync="showDialog" :title="$t('LanguageLib.SELECT_CATEGORY')">
              <category-tree @addcheck-treedata="getTreeCheckDataCategory" :categoryData="categoryData"
                             :checkCategoryId="ruleForm.parent.Id"
                             :oneNodeArr="categoryOpenArr"
                             :categoryTreeData="categoryTreeData"
                             labelName="categoryMemo"
              >

              </category-tree>
              <el-button style="float:right;margin-top:15px;" @click="confirmParentCategory" type="primary"
                         class="searchBtn">{{$t('LanguageLib.DETERMINE')}}
              </el-button>
            </el-dialog>

            <!--            维修故障分类-->
            <div class="parent">
              <p class="drawerText">&nbsp;{{$t('LanguageLib.MNT_QUESTION_CATEGORY')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="ruleForm.mntProblemCategory" clearable
                           multiple
                           :disabled="parentLevel!==2"
                           :placeholder="type==='add'?$t('LanguageLib.NO1'):$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in mntProblemCategoryList"
                    :key="item.id"
                    :label="item.problemCategory"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <!--默认优先级-->
            <div class="parent">
              <p class="drawerText">
                {{$t('LanguageLib.DEFAULT_PRIORITY')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="ruleForm.priority"
                           clearable
                           :disabled="parentLevel!==2"
                           :placeholder="type==='add'?$t('LanguageLib.NO1'):$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in priorityList"
                    :key="item.id"
                    :label="item.dataName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <!--供应商-->
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.DEFAULT_VENDOR')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="ruleForm.vendor"
                           clearable
                           :disabled="parentLevel!==2"
                           :placeholder="type==='add'?$t('LanguageLib.NO1'):$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in vendorList"
                    :key="item.id"
                    :label="item.vendorAlias"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.VISIBLE_ROLE')}}</p>
              <el-form-item>
                <el-select multiple style="width: 320px;" v-model="ruleForm.ruleDto.roleIds" clearable
                           :disabled="visibilityDisabled" :placeholder="$t('LanguageLib.NO_LIMIT')">
                  <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleId"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.VISIBLE_REGIO')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" class="TeInput" :value="ruleDtoDomainNames" readonly
                          :disabled="visibilityDisabled" :placeholder="$t('LanguageLib.NO_LIMIT')">
                  <el-button slot="append" class="openOrgList" :style="styleStrRegion" icon="el-icon-more"
                             :disabled="visibilityDisabled" @click="openCanOrgList"></el-button>
                </el-input>
                <div v-if="ruleDtoDomainNames" class="visibilityOrgNames" :class="{ disabled: visibilityDisabled }" v-html="ruleDtoDomainNames"></div>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog append-to-body width="360px" :title="$t('LanguageLib.SELECT_ORG')" :visible.sync="selectOrgDialog" :close-on-click-modal="false">
      <selectOrgLockChild @saveSelectOrg="saveSelectOrg" ref="selectOrgRef"></selectOrgLockChild>
    </el-dialog>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import selectOrgLockChild from '@/components/selectOrgLockChild.vue'
import storeMntApi from '../../api/storeMnt'
import storeinformationApi from '../../api/storeinformation'
import categoryTree from '@/components/categoryTree.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default {
  name: 'EditMntCategory',
  components: {
    categoryTree, selectOrgLockChild
  },
  data () {
    var checkCategoryName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.CLASSIFICATION_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.CLASSIFICATION_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      sub: {
        id: '',
        categoryCode: '',
        categoryMemo: ''
      },
      parentId: '',
      categoryData: [],
      categoryTreeData: [],
      categoryOpenArr: [],
      categoryObj: {},
      type: '',
      rules: {
        categoryName: [
          {
            validator: checkCategoryName,
            trigger: 'blur'
          }
        ]
      },
      OwnerLanguage: '', // 公司默认语言
      currentLang: '',
      langList: [],
      parentLevel: '',
      showDialog: false,
      selectOrgDialog: false,
      roleList: [],
      ruleDtoDomainNames: '',
      selectOrgDataIds: [],
      selectOrgDataObjs: [],
      level: '',
      mntProblemCategoryList: [],
      multiLinguals: [{
        id: '',
        categoryName: ''
      }], // 多语言列表
      vendorList: [],
      priorityList: [],
      loadingSave: false,
      styleStrRegion: '',
      ruleForm: {
        categoryName: '', // 类别名称
        parent: {
          id: '',
          name: ''
        }, // 上级分类
        serialNumber: 0,
        autoApproval: false,
        stackShelves: false,
        mntProblemCategory: [],
        priority: '',
        vendor: '',
        ruleDto: {
          roleIds: [],
          domainIds: []
        }
      }
    }
  },
  computed: {
    visibilityDisabled () {
      return (this.type === 'add' && this.parentLevel !== 0) || (this.type === 'edit' && this.level !== 1)
    },
    subDisabled () {
      // 添加状态
      if (this.type === 'add') {
        return true
      } else {
        // 编辑状态
        if (this.parentLevel === 0) {
          return true
        } else {
          return false
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    const query = JSON.parse(decodeURIComponent(to.query.myQuery))
    const type = query.type
    console.log(query)
    if (type === 'edit') {
      storeMntApi.getCategoryInfoDetail('get', '/mnt/getMntCategory?mcid=' + query.categoryObj.id)
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.level = res.data.level
            vm.categoryObj = res.data
            const obj = vm.categoryObj
            console.log(vm.categoryObj)
            vm.ruleForm.serialNumber = obj.categoryCode
            vm.ruleForm.autoApproval = obj.autoApproval
            vm.ruleForm.stackShelves = obj.isEnable
            vm.ruleForm.parent.id = obj.parentID.toUpperCase()
            const ruleDto = obj.ruleDto || {}
            vm.ruleForm.ruleDto.roleIds = ruleDto.roleIds || []
            vm.ruleForm.ruleDto.domainIds = ruleDto.domainIds || []
            vm.selectOrgDataIds = ruleDto.domainIds || []
            vm.selectOrgDataObjs = ruleDto.domainInfos || []
            vm.ruleDtoDomainNames = vm.selectOrgDataObjs.map(item => vm.$commonfun.RenderWxName('departmentName', item.domainName)).join(',')
            // 获取默认供应商数据源并赋值
            storeMntApi.getVendorList('get', '/mnt/getVendorsByMCID')
              .then(res => {
                vm.vendorList = res.data
                if (obj.defaultVendor) {
                  const vendor = vm.vendorList.filter(x => x.id === obj.defaultVendor)
                  if (vendor.toString() !== '') {
                    vm.ruleForm.vendor = vendor[0].id
                  }
                }
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })

            // 获取维修故障(问题)分类数据源并赋值
            storeMntApi.getMntProblemCategorys('get', '/mnt/getMntProblemCategorys')
              .then(res => {
                vm.mntProblemCategoryList = res.data
                if (obj.pcid) {
                  vm.ruleForm.mntProblemCategory = obj.pcid.split(',')
                  console.log(obj.pcid.split(','))
                }
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })

            // 获取优先级数据源并赋值
            storeMntApi.getPriorityList('get', '/mnt/getDatadicts?dataDictType=Priority')
              .then(res => {
                vm.priorityList = res.data
                if (obj.defaultPriority) {
                  const pri = vm.priorityList.filter(x => x.id === obj.defaultPriority)[0]
                  if (pri) {
                    vm.ruleForm.priority = pri.id
                  }
                }
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      storeMntApi.getSerialNumber('get', '/mnt/sortno')
        .then(
          res => {
            NProgress.done()
            next(vm => {
              vm.ruleForm.parent.id = query.parentId.toUpperCase()
              vm.ruleForm.serialNumber = res.data
            })
          })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    }
  },
  created () {
    const query = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
    this.type = query.type
    this.showDisabled = query.showDisabled

    this.getLangList()
    this.getCategoryTreeData()
    basicdataApi.getRolesList('get', '/user/rlist')
      .then(res => {
        this.roleList = res.data
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  methods: {
    openCanOrgList () {
      this.selectOrgDialog = true
      this.$nextTick(() => {
        this.$refs.selectOrgRef.renderSelectData({ selectDataAddPre: this.selectOrgDataIds, selectDataAddAllPre: this.selectOrgDataObjs })
      })
    },
    saveSelectOrg ({ selectDataIds, selectDataObjs }) {
      this.selectOrgDataIds = selectDataIds
      this.selectOrgDataObjs = selectDataObjs
      this.ruleForm.ruleDto.domainIds = selectDataIds
      this.ruleDtoDomainNames = selectDataObjs.map(item => this.$commonfun.RenderWxName('departmentName', item.domainName)).join(',')
      this.selectOrgDialog = false
    },
    // 根据分类判断等级
    getCategoryLevel (id) {
      if (id === this.ownerId) {
        return 0
      }
      const pr = this.categoryData.find(x => x.id === id)
      return pr.level
    },
    // 确定更改上级分类
    confirmParentCategory () {
      this.showDialog = false
      this.ruleForm.parent.id = this.sub.id
      this.ruleForm.parent.name = this.sub.categoryMemo
      this.parentLevel = this.getCategoryLevel(this.ruleForm.parent.id)
    },
    getCategoryTreeData () {
      storeMntApi.getMntCategoryTreeData('get', '/mnt/mntcategorytree?showDisable=' + this.showDisabled)
        .then(res => {
          console.log('调用树接口')
          // 只要调用树接口,就一定要给树赋新的值
          // 不管你第几次进来,都是直接把值刷新,然后塞新的假根节点
          this.categoryData = res.data
          this.ownerId = this.$commonfun.localStorage.getitem('ownerId').toUpperCase()
          if (!this.ownerId) {
            this.ownerId = res.data[0].ownerID.toUpperCase()
          }
          this.categoryData.forEach(x => {
            x.id = x.id.toUpperCase()
            x.parentID = x.parentID.toUpperCase()
            x.ownerID = x.ownerID.toUpperCase()

            if (x.id === this.ruleForm.parent.id) {
              this.ruleForm.parent.name = x.categoryMemo
              this.parentLevel = x.level
            }
          })
          if (this.ruleForm.parent.name === '' && this.ruleForm.parent.id === this.ownerId) {
            this.ruleForm.parent.name = this.$t('LanguageLib.MAINTENANCE_CLASSIFICATION')
            this.parentLevel = 0
          }

          let ctd
          if (this.parentLevel === 0) {
            const fakeRoot = {
              categoryMemo: this.$t('LanguageLib.MNT_CATEGORY'),
              parentID: '',
              categoryCode: null,
              ownerID: this.ownerId,
              id: this.ownerId
            }
            this.categoryData.unshift(fakeRoot)
            // 对树数据做处理,然后赋新的值
            const ctd = this.$commonfun.toCategoryTree(res.data, 'childCategoryTrees', 'id', 'parentID')
            ctd.forEach(x => {
              x.id = x.id.toUpperCase()
              x.parentID = x.parentID.toUpperCase()
              x.ownerID = x.ownerID.toUpperCase()
            })
          } else if (this.parentLevel === 1) {
            // 如果是二级数据,把类别data筛选一下,只保留一级数据
            const level1 = res.data.filter(x => x.level === 1)
            ctd = level1
            ctd.forEach(x => {
              x.id = x.id.toUpperCase()
              x.parentID = x.parentID.toUpperCase()
              x.ownerID = x.ownerID.toUpperCase()
            })
          } else {
            // 如果是三级数据,把类别data筛选,保留二级数据
            const level2 = res.data.filter(x => x.level === 2)
            ctd = level2
            ctd.forEach(x => {
              x.id = x.id.toUpperCase()
              x.parentID = x.parentID.toUpperCase()
              x.ownerID = x.ownerID.toUpperCase()
            })
          }
          this.categoryTreeData = ctd
        }
        ).catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    getTreeCheckDataCategory (data) {
      console.log(data)
      this.sub = data
    },
    getCategoryInfoDetail () {

    },
    inputCategory (e) {
      // 每次打字都修改对应的语言的名字
      this.multiLinguals[this.currentLang].categoryName = e
    },
    changeLanguage (e) {
      // 每次改语言,都把input框应该有的内容给读进去
      this.ruleForm.categoryName = this.multiLinguals[this.currentLang].categoryName
    },
    submit () {
      if (this.type === 'add') {
        const newMnt = {}
        newMnt.categoryMemo = this.multiLinguals[this.OwnerLanguage].categoryName
        newMnt.level = this.parentLevel + 1
        newMnt.parentId = this.ruleForm.parent.id
        newMnt.categoryCode = this.ruleForm.serialNumber
        newMnt.autoApproval = this.ruleForm.autoApproval
        newMnt.defaultVendor = this.ruleForm.vendor
        if (newMnt.defaultVendor === '') {
          newMnt.vendorName = ''
        } else {
          newMnt.vendorName = this.vendorList.find(x => x.id === newMnt.defaultVendor).vendorAlias
        }
        newMnt.defaultPriority = this.ruleForm.priority
        newMnt.multiLinguals = this.multiLinguals.map(x => {
          const y = {}
          y.ownerLanguage = x.typeValue
          y.content = x.categoryName
          return y
        }).filter(v => v.content !== '')
        newMnt.pcid = this.ruleForm.mntProblemCategory.toString()
        newMnt.ruleDto = this.ruleForm.ruleDto
        storeMntApi.createMntCategory('post', '/mnt/createMntCategory', newMnt)
          .then(res => {
            console.log(res)
            const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
            const x = {
              isSearch: qr.isSearch,
              batchDisabled: qr.batchDisabled,
              showDisabled: qr.showDisabled,
              currentPage: qr.currentPage,
              pageSize: qr.pageSize,
              searchText: qr.searchText,
              sort: qr.sort,
              sortOrder: qr.sortOrder,
              type: 'add',
              parentId: qr.parentId
            }
            const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
            this.$router.push({
              path: '/storemnt/mntcategory',
              query: {
                fromPath: 'editmntcategory',
                myQuery: myQuery
              }
            })
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      } else {
        const editMnt = {}
        editMnt.id = this.categoryObj.id
        editMnt.categoryMemo = this.multiLinguals[this.OwnerLanguage].categoryName
        editMnt.level = this.parentLevel + 1
        editMnt.parentId = this.ruleForm.parent.id
        editMnt.categoryCode = this.ruleForm.serialNumber
        editMnt.autoApproval = this.ruleForm.autoApproval
        editMnt.defaultVendor = this.ruleForm.vendor
        editMnt.isEnable = this.ruleForm.stackShelves
        if (editMnt.defaultVendor === '') {
          editMnt.vendorName = ''
        } else {
          editMnt.vendorName = this.vendorList.find(x => x.id === editMnt.defaultVendor).vendorAlias
        }
        editMnt.defaultPriority = this.ruleForm.priority
        editMnt.multiLinguals = this.multiLinguals.map(x => {
          const y = {}
          y.ownerLanguage = x.typeValue
          y.content = x.categoryName
          return y
        }).filter(v => v.content !== '')
        editMnt.pcid = this.ruleForm.mntProblemCategory.toString()
        editMnt.ruleDto = this.ruleForm.ruleDto

        storeMntApi.updateMntCategory('post', '/mnt/updateMntCategory', editMnt)
          .then(res => {
            console.log(res)
            const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
            const x = {
              isSearch: qr.isSearch,
              batchDisabled: qr.batchDisabled,
              showDisabled: qr.showDisabled,
              currentPage: qr.currentPage,
              pageSize: qr.pageSize,
              searchText: qr.searchText,
              sort: qr.sort,
              sortOrder: qr.sortOrder,
              type: 'add',
              parentId: qr.parentId
            }
            const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
            this.$router.push({
              path: '/storemnt/mntcategory',
              query: {
                fromPath: 'editmntcategory',
                myQuery: myQuery
              }
            })
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }
    },
    goReturn () {
      const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
      const x = {
        isSearch: qr.isSearch,
        batchDisabled: qr.batchDisabled,
        showDisabled: qr.showDisabled,
        currentPage: qr.currentPage,
        pageSize: qr.pageSize,
        searchText: qr.searchText,
        sort: qr.sort,
        sortOrder: qr.sortOrder,
        type: 'add',
        parentId: qr.parentId
      }
      const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
      this.$router.push({
        path: '/storemnt/mntcategory',
        query: {
          fromPath: 'editmntcategory',
          myQuery: myQuery
        }
      })
    },
    getNo () {
      storeMntApi.getSerialNumber('get', '/mnt/sortno')
        .then(
          res => {
            this.ruleForm.serialNumber = res.data
          }
        )
    },
    getLangList () {
      // 获取店铺多语言列表
      storeinformationApi.getLang('get', '/BasicData/GetLang', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(res => {
          var OwnerLanguage = this.$commonfun.localStorage.getitem('OwnerLanguage') * 1
          this.OwnerLanguage = OwnerLanguage
          console.log(this.OwnerLanguage)

          // 对langlist做一些预处理,并且给currentLang赋值
          this.langList = res.data
          this.multiLinguals = this.langList.map(x => {
            x.categoryName = ''
            return x
          })
          this.langList = this.langList.map(x => {
            const obj = {}
            obj.id = x.typeValue
            obj.content = x.typeDes
            if (obj.id === OwnerLanguage) {
              this.currentLang = OwnerLanguage
            }
            return obj
          })
          const obj = this.categoryObj
          obj.multiLinguals = obj.multiLinguals.map(x => {
            const y = {}
            y.id = x.ownerLanguage
            y.content = x.content
            return y
          })

          for (let i = 0; i < this.multiLinguals.length; i++) {
            for (let j = 0; j < obj.multiLinguals.length; j++) {
              if (this.multiLinguals[i].typeValue === obj.multiLinguals[j].id) {
                this.multiLinguals[i].categoryName = obj.multiLinguals[j].content
              }
            }
          }
          this.changeLanguage()
          this.$forceUpdate()
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    openCategoryList () {
      if (this.type === 'edit') {
        this.showDialog = true
      }
    }
  }

}
</script>

<style lang="scss">
  #editMntCategory {
    height: 100%;
    width: 100%;

    .buttonSlot {
      padding: 0 4px;
      color: white;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 5%;
      cursor: pointer;
      width: 98px;
      margin: 0 1px;
      text-overflow: ellipsis;
      overflow: hidden;
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      margin-bottom: 15px;

      .buttonContent {
        display: inline-block;
        margin-right: 3px;
      }

      .buttonContent.text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .storePic {
      overflow: hidden;

      .parent {
        float: left;
        width: auto;
        position: relative;
        margin-bottom: 16px;

        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 1px solid #E1E1E1;
        }

        .drawerText {
          width: 100px;
          text-align: center;
          margin-top: 4px;
        }

        input {
          position: absolute;
          left: 10px;
          width: calc(100% - 10px);
          height: 30px;
          top: 0;
          opacity: 0;
        }

        .el-button--primary {
          margin-left: 2px;
          display: inherit;
          margin-bottom: 8px;
          font-size: 14px;
        }

        .el-button--primary:nth-of-type(2) {
          background: #fff;
          color: #C0C4CC;
          border: 1px solid rgba(216, 220, 230, 1);
        }
      }
    }

    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }

    .left {
      width: 320px !important;
    }

    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;

      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }

      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }

      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }

    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }

    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc(100% - 66px);
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 100px;
      padding-top: 15px;
      box-sizing: border-box;

      /*组织树视图*/
      .el-dialog {
        overflow: hidden;
        width: 360px !important;

        .left {
          background: #fff;
          width: 320px;
          height: 535px;
          border: 1px solid #f2f2f2;

          .fifter {
            height: 30px;
            padding: 10px 0 10px 20px;
            margin: 0 auto;
            border-bottom: 1px solid #f2f2f2;

            .el-input {
              width: 220px;

              input {
                height: 30px;
                line-height: 30px;
                border-radius: 20px;
              }

              .el-icon-search {
                line-height: 30px;
              }
            }

            .el-button--text {
              margin-left: 8px;
              padding: 7px 0;
              color: #3BC6B9;
            }
          }

          .treeBox {
            height: calc(100% - 51px);
            overflow: auto;
            width: 320px;
          }

          .treeBox::-webkit-scrollbar {
            width: 10px;
            height: 10px;
          }

          .treeBox::-webkit-scrollbar-thumb {
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
            background: #E1E1E1;
          }

          .treeBox::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
            border-radius: 5px;
            background: #fff;
          }
        }
      }

      .el-textarea__inner {
        font: 400 13.3333px Arial;
      }

      .cropper-content {
        background: #f2f2f2;
        padding-top: 20px;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .cropper {
          width: 400px;
          height: 400px;
          margin: 0 auto;
        }

        .show-preview {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;

          .preview {
            overflow: hidden;
            border-radius: 50%;
            border: 1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
          }
        }
      }

      .footer-btn {
        padding-top: 20px;
        background: #f2f2f2;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .scope-btn {
          width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          -webkit-justify-content: space-between;
          margin: 0 auto;

          .el-button--primary {
            max-width: 98px;
            margin: 0 1px;
            text-overflow: ellipsis;
            overflow: hidden;
            background-color: #3BC6B9;
            border-color: #3BC6B9;
            height: 30px;
            margin-bottom: 15px;
            margin-left: 0;
          }

          span {
            display: block;
            float: left;
          }
        }

        .upload-btn {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;
        }
      }

      .label-success {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: rgb(103, 194, 58) !important;
        border-color: rgb(103, 194, 58) !important;
      }

      .label-success:hover {
        background-color: rgb(133, 206, 97) !important;
        border-color: rgb(133, 206, 97) !important;
      }

      .dialogStoreComm {
        .el-dialog {
          width: 500px !important;
          height: 660px !important;

          .el-dialog__header {
            padding: 20px;
            border-bottom: 1px solid #EBEEF5;
          }

          .el-dialog__body {
            padding: 20px;
          }
        }
      }

      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }

      h4 {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding-top: 8px;
      }

      .contentTop {
        padding: 15px 0 24px 20px;

        .el-checkbox {
          margin-right: 30px;
        }
      }

      .infoForm {
        padding: 15px 0 0 20px;

        .parent {
          width: 50%;
          vertical-align: top;
          display: inline-block;
        }
      }
    }

    /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      padding: 7px 20px;
      margin-bottom: 15px;
      margin-left: 0;
    }

    .colorRed {
      color: red;
    }

    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
  }

  .el-range-editor.el-input__inner {
    width: 320px;
  }

  .el-textarea {
    textarea {
      height: 124px;
    }
  }
  #editMntCategory .visibilityOrgNames {
    width: 260px;
    height: 38px;
    position: absolute;
    background: #fff;
    top: 1px;
    left: 2px;
    text-indent: 14px;
    color: #666;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &.disabled {
      background: #F5F7FA;
      color: #C0C4CC;
    }
  }
</style>
